import React, {Component} from 'react';
import { connect } from 'react-redux'
import {Link} from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { useNavigate  , Route  } from "react-router-dom";
import Header  from './header';
//import ProtectedRoute from 'protectedRoutes'

class Dashboard extends Component {

    constructor (props) {
        super (props)

        this.state = {
            limit: 5,
            hasMoreItems: true,
            username:'',
            password:''
        };

        this.handleSubmit = this.handleSubmit.bind(this); 
    }

    componentDidMount(){
    //  navigate = useNavigate();
        var loaderElement = document.querySelector('#load_screen');
        setTimeout( function() {
            loaderElement.style.display = "none";
        }, 3000); 
      }

    updateUsername(event){
        this.setState({username:event.target.value})
        console.log(this.state.username);

    }

    updatePassword(event){
         
        this.setState({password:event.target.value})
        console.log(this.state.password);

    }
    handleSubmit(event) {
        if(this.state.password.length > 0 && this.state.username.length>0){
            var loginDetails = new FormData();
            loginDetails.append('email', this.state.username);
            loginDetails.append('password', this.state.password);
            loginDetails.append('OP', 'loginUser');
            axios.post('http://127.0.0.1/BMS/my-app/API/users.php',loginDetails)
              .then(function (response) {
                console.log(response.data.status);
                if(response.data.status =='true'){
                    toast.success('Logging In', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        closeButton:false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        });
                }else{
                    toast.error(response.data.response, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        closeButton:false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        });
                }
              })
              .catch(function (error) {
                console.log(error);
              });
        }else{
            toast.error("Insufficient Details", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                closeButton:false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                });
        }
      
          
        event.preventDefault();
      }
    
    render (){
      //  const {products, addToCart, symbol, addToWishlist, addToCompare} = this.props;
      return (
        <div>
            {/* BEGIN LOADER */}
                <div id="load_screen"> <div className="loader"> <div className="loader-content">
                  <div className="spinner-grow align-self-center" />
            </div></div></div>
            {/*  END LOADER */}
        
          <Header/>
          {/*  END NAVBAR  */}
          {/*  BEGIN MAIN CONTAINER  */}
          <div className="main-container" id="container">
            <div className="overlay" />
            <div className="search-overlay" />
            {/*  BEGIN CONTENT PART  */}
            <div id="content" className="main-content">
              <div className="layout-px-spacing">
                <div className="page-header">
                  <div className="page-title">
                    <h3>Welcome Username: </h3>
                  </div>
                  <div className="toggle-switch">
                    <label className="switch s-icons s-outline  s-outline-secondary">
                      <input type="checkbox" defaultChecked className="theme-shifter" />
                      {/* <span className="slider round">
                        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-sun"><circle cx={12} cy={12} r={5} /><line x1={12} y1={1} x2={12} y2={3} /><line x1={12} y1={21} x2={12} y2={23} /><line x1="4.22" y1="4.22" x2="5.64" y2="5.64" /><line x1="18.36" y1="18.36" x2="19.78" y2="19.78" /><line x1={1} y1={12} x2={3} y2={12} /><line x1={21} y1={12} x2={23} y2={12} /><line x1="4.22" y1="19.78" x2="5.64" y2="18.36" /><line x1="18.36" y1="5.64" x2="19.78" y2="4.22" /></svg>
                        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-moon"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" /></svg>
                      </span> */}
                    </label>
                  </div>
                </div>
                <div className="row layout-top-spacing">
                                  
                  <div className="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
                    <div className="widget-three">
                      <div className="widget-heading">
                        <h5 className>Summary</h5>
                      </div>
                      <div className="widget-content">
                        <div className="order-summary">
                          <div className="summary-list">
                            <div className="w-icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-shopping-bag"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" /><line x1={3} y1={6} x2={21} y2={6} /><path d="M16 10a4 4 0 0 1-8 0" /></svg>
                            </div>
                            <div className="w-summary-details">
                              <div className="w-summary-info">
                                <h6>Total Bids</h6>
                                <p className="summary-count">92,600</p>
                              </div>
                              <div className="w-summary-stats">
                                <div className="progress">
                                  <div className="progress-bar bg-gradient-secondary" role="progressbar" style={{width: '90%'}} aria-valuenow={90} aria-valuemin={0} aria-valuemax={100} />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="summary-list">
                            <div className="w-icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-tag"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" /><line x1={7} y1={7} x2={7} y2={7} /></svg>
                            </div>
                            <div className="w-summary-details">
                              <div className="w-summary-info">
                                <h6>Approved Bids</h6>
                                <p className="summary-count">37,515</p>
                              </div>
                              <div className="w-summary-stats">
                                <div className="progress">
                                  <div className="progress-bar bg-gradient-success" role="progressbar" style={{width: '65%'}} aria-valuenow={65} aria-valuemin={0} aria-valuemax={100} />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="summary-list">
                            <div className="w-icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-credit-card"><rect x={1} y={4} width={22} height={16} rx={2} ry={2} /><line x1={1} y1={10} x2={23} y2={10} /></svg>
                            </div>
                            <div className="w-summary-details">
                              <div className="w-summary-info">
                                <h6>Pending Bids</h6>
                                <p className="summary-count">5,085</p>
                              </div>
                              <div className="w-summary-stats">
                                <div className="progress">
                                  <div className="progress-bar bg-gradient-warning" role="progressbar" style={{width: '80%'}} aria-valuenow={80} aria-valuemin={0} aria-valuemax={100} />
                                </div>
                              </div>
                            </div>
                          </div>


                          <div className="summary-list">
                            <div className="w-icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-credit-card"><rect x={1} y={4} width={22} height={16} rx={2} ry={2} /><line x1={1} y1={10} x2={23} y2={10} /></svg>
                            </div>
                            <div className="w-summary-details">
                              <div className="w-summary-info">
                                <h6>Pending Bids</h6>
                                <p className="summary-count">5,085</p>
                              </div>
                              <div className="w-summary-stats">
                                <div className="progress">
                                  <div className="progress-bar bg-gradient-warning" role="progressbar" style={{width: '80%'}} aria-valuenow={80} aria-valuemin={0} aria-valuemax={100} />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="summary-list">
                            <div className="w-icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-credit-card"><rect x={1} y={4} width={22} height={16} rx={2} ry={2} /><line x1={1} y1={10} x2={23} y2={10} /></svg>
                            </div>
                            <div className="w-summary-details">
                              <div className="w-summary-info">
                                <h6>Users</h6>
                                <p className="summary-count">55,085</p>
                              </div>
                              <div className="w-summary-stats">
                                <div className="progress">
                                  <div className="progress-bar bg-gradient-warning" role="progressbar" style={{width: '80%'}} aria-valuenow={80} aria-valuemin={0} aria-valuemax={100} />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 layout-spacing">
                    <div className="widget widget-activity-four">
                      <div className="widget-heading">
                        <h5 className>Recent Activities</h5>
                      </div>
                      <div className="widget-content">
                        <div className="mt-container mx-auto">
                          <div className="timeline-line">
                            <div className="item-timeline timeline-primary">
                              <div className="t-dot" data-original-title title>
                              </div>
                              <div className="t-text">
                                <p><span>Updated</span> Server Logs</p>
                                <span className="badge badge-danger">Pending</span>
                                <p className="t-time">Just Now</p>
                              </div>
                            </div>
                            <div className="item-timeline timeline-success">
                              <div className="t-dot" data-original-title title>
                              </div>
                              <div className="t-text">
                                <p>Send Mail to <a href="javascript:void(0);">HR</a> and <a href="javascript:void(0);">Admin</a></p>
                                <span className="badge badge-success">Completed</span>
                                <p className="t-time">2 min ago</p>
                              </div>
                            </div>
                            <div className="item-timeline  timeline-danger">
                              <div className="t-dot" data-original-title title>
                              </div>
                              <div className="t-text">
                                <p>Backup <span>Files EOD</span></p>
                                <span className="badge badge-danger">Pending</span>
                                <p className="t-time">14:00</p>
                              </div>
                            </div>
                            <div className="item-timeline  timeline-dark">
                              <div className="t-dot" data-original-title title>
                              </div>
                              <div className="t-text">
                                <p>Collect documents from <a href="javascript:void(0);">Sara</a></p>
                                <span className="badge badge-success">Completed</span>
                                <p className="t-time">16:00</p>
                              </div>
                            </div>
                            <div className="item-timeline  timeline-warning">
                              <div className="t-dot" data-original-title title>
                              </div>
                              <div className="t-text">
                                <p>Conference call with <a href="javascript:void(0);">Marketing Manager</a>.</p>
                                <span className="badge badge-primary">In progress</span>
                                <p className="t-time">17:00</p>
                              </div>
                            </div>
                            <div className="item-timeline  timeline-secondary">
                              <div className="t-dot" data-original-title title>
                              </div>
                              <div className="t-text">
                                <p>Rebooted Server</p>
                                <span className="badge badge-success">Completed</span>
                                <p className="t-time">17:00</p>
                              </div>
                            </div>
                            <div className="item-timeline  timeline-warning">
                              <div className="t-dot" data-original-title title>
                              </div>
                              <div className="t-text">
                                <p>Send contract details to Freelancer</p>
                                <span className="badge badge-danger">Pending</span>
                                <p className="t-time">18:00</p>
                              </div>
                            </div>
                            <div className="item-timeline  timeline-dark">
                              <div className="t-dot" data-original-title title>
                              </div>
                              <div className="t-text">
                                <p>Kelly want to increase the time of the project.</p>
                                <span className="badge badge-primary">In Progress</span>
                                <p className="t-time">19:00</p>
                              </div>
                            </div>
                            <div className="item-timeline  timeline-success">
                              <div className="t-dot" data-original-title title>
                              </div>
                              <div className="t-text">
                                <p>Server down for maintanence</p>
                                <span className="badge badge-success">Completed</span>
                                <p className="t-time">19:00</p>
                              </div>
                            </div>
                            <div className="item-timeline  timeline-secondary">
                              <div className="t-dot" data-original-title title>
                              </div>
                              <div className="t-text">
                                <p>Malicious link detected</p>
                                <span className="badge badge-warning">Block</span>
                                <p className="t-time">20:00</p>
                              </div>
                            </div>
                            <div className="item-timeline  timeline-warning">
                              <div className="t-dot" data-original-title title>
                              </div>
                              <div className="t-text">
                                <p>Rebooted Server</p>
                                <span className="badge badge-success">Completed</span>
                                <p className="t-time">23:00</p>
                              </div>
                            </div>
                          </div>                                    
                        </div>
                        <div className="tm-action-btn">
                          <button className="btn">View All <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-chevron-down"><polyline points="6 9 12 15 18 9" /></svg></button>
                        </div>
                      </div>
                    </div>
                  </div>
  
                  <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
                    <div className="widget widget-table-two">
                      <div className="widget-heading">
                        <h5 className>Recent Bids</h5>
                      </div>
                      <div className="widget-content">
                        <div className="table-responsive">
                          <table className="table">
                            <thead>
                              <tr>
                                <th><div className="th-content">Customer</div></th>
                                <th><div className="th-content">Product</div></th>
                                <th><div className="th-content">Invoice</div></th>
                                <th><div className="th-content th-heading">Price</div></th>
                                <th><div className="th-content">Status</div></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td><div className="td-content customer-name"><img src="https://ui-avatars.com/api/?name=BMS&color=7F9CF5&background=EBF4FF" alt="avatar" />Andy King</div></td>
                                <td><div className="td-content product-brand">Nike Sport</div></td>
                                <td><div className="td-content">#76894</div></td>
                                <td><div className="td-content pricing"><span className>$88.00</span></div></td>
                                <td><div className="td-content"><span className="badge outline-badge-primary">Shipped</span></div></td>
                              </tr>
                              <tr>
                                <td><div className="td-content customer-name"><img src="https://ui-avatars.com/api/?name=BMS&color=7F9CF5&background=EBF4FF" alt="avatar" />Irene Collins</div></td>
                                <td><div className="td-content product-brand">Speakers</div></td>
                                <td><div className="td-content">#75844</div></td>
                                <td><div className="td-content pricing"><span className>$84.00</span></div></td>
                                <td><div className="td-content"><span className="badge outline-badge-success">Paid</span></div></td>
                              </tr>
                              <tr>
                                <td><div className="td-content customer-name"><img src="https://ui-avatars.com/api/?name=BMS&color=7F9CF5&background=EBF4FF" alt="avatar" />Laurie Fox</div></td>
                                <td><div className="td-content product-brand">Camera</div></td>
                                <td><div className="td-content">#66894</div></td>
                                <td><div className="td-content pricing"><span className>$126.04</span></div></td>
                                <td><div className="td-content"><span className="badge outline-badge-danger">Pending</span></div></td>
                              </tr>
                              <tr>
                                <td><div className="td-content customer-name"><img src="https://ui-avatars.com/api/?name=BMS&color=7F9CF5&background=EBF4FF" alt="avatar" />Luke Ivory</div></td>
                                <td><div className="td-content product-brand">Headphone</div></td>
                                <td><div className="td-content">#46894</div></td>
                                <td><div className="td-content pricing"><span className>$56.07</span></div></td>
                                <td><div className="td-content"><span className="badge outline-badge-success">Paid</span></div></td>
                              </tr>
                              <tr>
                                <td><div className="td-content customer-name"><img src="https://ui-avatars.com/api/?name=BMS&color=7F9CF5&background=EBF4FF" alt="avatar" />Ryan Collins</div></td>
                                <td><div className="td-content product-brand">Sport</div></td>
                                <td><div className="td-content">#89891</div></td>
                                <td><div className="td-content pricing"><span className>$108.09</span></div></td>
                                <td><div className="td-content"><span className="badge outline-badge-primary">Shipped</span></div></td>
                              </tr>
                              <tr>
                                <td><div className="td-content customer-name"><img src="https://ui-avatars.com/api/?name=BMS&color=7F9CF5&background=EBF4FF" alt="avatar" />Nia Hillyer</div></td>
                                <td><div className="td-content product-brand">Sunglasses</div></td>
                                <td><div className="td-content">#26974</div></td>
                                <td><div className="td-content pricing"><span className>$168.09</span></div></td>
                                <td><div className="td-content"><span className="badge outline-badge-primary">Shipped</span></div></td>
                              </tr>
                              <tr>
                                <td><div className="td-content customer-name"><img src="https://ui-avatars.com/api/?name=BMS&color=7F9CF5&background=EBF4FF" alt="avatar" />Sonia Shaw</div></td>
                                <td><div className="td-content product-brand">Watch</div></td>
                                <td><div className="td-content">#76844</div></td>
                                <td><div className="td-content pricing"><span className>$110.00</span></div></td>
                                <td><div className="td-content"><span className="badge outline-badge-success">Paid</span></div></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
                    <div className="widget widget-table-three">
                      <div className="widget-heading">
                        <h5 className>Recent Users</h5>
                      </div>
                      <div className="widget-content">
                        <div className="table-responsive">
                          <table className="table">
                            <thead>
                              <tr>
                                <th><div className="th-content">Product</div></th>
                                <th><div className="th-content th-heading">Price</div></th>
                                <th><div className="th-content th-heading">Discount</div></th>
                                <th><div className="th-content">Sold</div></th>
                                <th><div className="th-content">Source</div></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td><div className="td-content product-name"><img src="https://ui-avatars.com/api/?name=BMS&color=7F9CF5&background=EBF4FF" alt="product" />Speakers</div></td>
                                <td><div className="td-content"><span className="pricing">$84.00</span></div></td>
                                <td><div className="td-content"><span className="discount-pricing">$10.00</span></div></td>
                                <td><div className="td-content">240</div></td>
                                <td><div className="td-content"><a href="javascript:void(0);" className>Direct</a></div></td>
                              </tr>
                              <tr>
                                <td><div className="td-content product-name"><img src="https://ui-avatars.com/api/?name=BMS&color=7F9CF5&background=EBF4FF" alt="product" />Sunglasses</div></td>
                                <td><div className="td-content"><span className="pricing">$56.07</span></div></td>
                                <td><div className="td-content"><span className="discount-pricing">$5.07</span></div></td>
                                <td><div className="td-content">190</div></td>
                                <td><div className="td-content"><a href="javascript:void(0);" className>Google</a></div></td>
                              </tr>
                              <tr>
                                <td><div className="td-content product-name"><img src="https://ui-avatars.com/api/?name=BMS&color=7F9CF5&background=EBF4FF" alt="product" />Watch</div></td>
                                <td><div className="td-content"><span className="pricing">$88.00</span></div></td>
                                <td><div className="td-content"><span className="discount-pricing">$20.00</span></div></td>
                                <td><div className="td-content">66</div></td>
                                <td><div className="td-content"><a href="javascript:void(0);" className>Ads</a></div></td>
                              </tr>
                              <tr>
                                <td><div className="td-content product-name"><img src="https://ui-avatars.com/api/?name=BMS&color=7F9CF5&background=EBF4FF" alt="product" />Laptop</div></td>
                                <td><div className="td-content"><span className="pricing">$110.00</span></div></td>
                                <td><div className="td-content"><span className="discount-pricing">$33.00</span></div></td>
                                <td><div className="td-content">35</div></td>
                                <td><div className="td-content"><a href="javascript:void(0);" className>Email</a></div></td>
                              </tr>
                              <tr>
                                <td><div className="td-content product-name"><img src="https://ui-avatars.com/api/?name=BMS&color=7F9CF5&background=EBF4FF" alt="product" />Camera</div></td>
                                <td><div className="td-content"><span className="pricing">$126.04</span></div></td>
                                <td><div className="td-content"><span className="discount-pricing">$26.04</span></div></td>
                                <td><div className="td-content">30</div></td>
                                <td><div className="td-content"><a href="javascript:void(0);" className>Referral</a></div></td>
                              </tr>
                              <tr>
                                <td><div className="td-content product-name"><img src="https://ui-avatars.com/api/?name=BMS&color=7F9CF5&background=EBF4FF" alt="product" />Shoes</div></td>
                                <td><div className="td-content"><span className="pricing">$108.09</span></div></td>
                                <td><div className="td-content"><span className="discount-pricing">$47.09</span></div></td>
                                <td><div className="td-content">130</div></td>
                                <td><div className="td-content"><a href="javascript:void(0);" className>Google</a></div></td>
                              </tr>
                              <tr>
                                <td><div className="td-content product-name"><img src="https://ui-avatars.com/api/?name=BMS&color=7F9CF5&background=EBF4FF" alt="product" />Headphone</div></td>
                                <td><div className="td-content"><span className="pricing">$168.09</span></div></td>
                                <td><div className="td-content"><span className="discount-pricing">$60.09</span></div></td>
                                <td><div className="td-content">170</div></td>
                                <td><div className="td-content"><a href="javascript:void(0);" className>Ads</a></div></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="footer-wrapper">
                  <div className="footer-section f-section-1">
                    <p className>Copyright © 2022 <a target="_blank" href="#">Oliac Japan</a>, All rights reserved.</p>
                  </div>
                  <div className="footer-section f-section-2">
                    <p className>Coded with <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-heart"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" /></svg></p>
                  </div>
                </div>
              </div>
            </div>
            {/*  END CONTENT PART  */}
          </div>
          {/* END MAIN CONTAINER */}
          {/* BEGIN GLOBAL MANDATORY SCRIPTS */}
          {/* END GLOBAL MANDATORY SCRIPTS */}
          {/* BEGIN PAGE LEVEL PLUGINS/CUSTOM SCRIPTS */}
          {/* BEGIN PAGE LEVEL PLUGINS/CUSTOM SCRIPTS */}
        </div>
      );
    }
}
const mapStateToProps = (state) => ({
 
})
 
export default Dashboard; 